export const DATA_TYPE = {
  QUESTION: 'question',
  GROUP: 'group'
}

export const QUESTION_TYPE = {
  TEXT: 'text',
  SELECT: 'dropdown',
  CHECKBOX: 'checkbox',
  VIDEO: 'video',
  ATTACHMENT: 'portfolio',
  SINGLE_SELECT: 'single_select',
  MULTIPLE_SELECT: 'multiple_select',
  DATE: 'date'
}

export const HAS_OPTIONS_QUESTION_TYPES = [QUESTION_TYPE.SELECT, QUESTION_TYPE.CHECKBOX, QUESTION_TYPE.SINGLE_SELECT, QUESTION_TYPE.MULTIPLE_SELECT]

export const HAS_KNOCKOUT_OPTIONS_QUESTION_TYPES = [QUESTION_TYPE.SELECT, QUESTION_TYPE.SINGLE_SELECT]

// 支持树形分支结构的题型（选项题都可以设置子题）
export const TREE_SUPPORTED_QUESTION_TYPES = [QUESTION_TYPE.SELECT, QUESTION_TYPE.SINGLE_SELECT]

export const VIDEO_DURATION = {
  S30: '30s',
  S60: '60s',
  S90: '90s'
}

export const VISIBILITY_TYPE = {
  IE: 'IE',
  E: 'E',
  I: 'I'
}

export const MAX_NORMAL_QUESTION_VIDEO_TYPE_SIZE_LIMIT = 6
export const MAX_NORMAL_QUESTION_ATTACHMENT_TYPE_SIZE_LIMIT = 6
